// Navigation des Moduls `insights` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul insights.
import { ChartBar } from '@phosphor-icons/react';
import type { RoleKey } from '@web/registry';
import { defineMeta } from '@web/registry/define';

/**
 * Wer Insights sieht (UX §5.16 I1; Server entscheidet je Abschnitt über can()): LM, HOD, PERF, CL, CEO,
 * COMP (Gehaltsteil), ADM (Prozesszahlen und SaaS-Kosten) und HR (Prozesszahlen, PIP-Ausgänge).
 */
export const INSIGHTS_ROLES: readonly RoleKey[] = [
  'LM',
  'HOD',
  'PERF',
  'CL',
  'CEO',
  'COMP',
  'ADM',
  'HR',
];

export default defineMeta({
  key: 'insights',
  title: 'Insights',
  nav: {
    people: [
      {
        key: 'insights.tab',
        label: 'Insights',
        icon: ChartBar,
        path: '/insights',
        roles: INSIGHTS_ROLES,
        order: 50,
        area: 'tabs:performance',
      },
    ],
  },
});
